import { secretariaArbitralService } from '@/features/secretaria-arbitral/store';
import type {
  ListProcessosFilters,
  ListProcessosResponse,
} from '@/features/secretaria-arbitral/types';

import type { ArbitragensGlobaisParams } from '../../types/arbitragensGlobais';

/**
 * Consulta da empresa inteira: sem `origem` (a API devolve todas as origens juntas)
 * e sem recorte de escritório. O `X-Workspace-Id` não entra porque `requestBuilder` já
 * dispensa o header em toda rota `/admin`.
 */
export const arbitragensGlobaisService = {
  list: (params: ArbitragensGlobaisParams): Promise<ListProcessosResponse> => {
    const filtros: ListProcessosFilters = {
      page: params.page,
      limit: params.limit,
      sortBy: params.sortBy,
      sortOrder: params.sortOrder,
      ...(params.search ? { search: params.search } : {}),
      ...(params.status?.length ? { status: params.status } : {}),
      ...(params.rito?.length ? { rito: params.rito } : {}),
    };

    return secretariaArbitralService.listarProcessos(filtros);
  },
};
